<template>
  <div class="scroll-page">
    <AppHeader @refreshPage="init" />
    <div
      class="container"
      v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="loading"
      infinite-scroll-distance="10">
      <div class="page-header">
        <div class="icon-bar back" @click="handleBack"></div>
        <div class="page-title sub">{{ $t('new.text34') }}</div>
        <div class="right" @click="handleAdd">+ {{ $t('new.text35') }}</div>
      </div>
      <div class="detail-box">
        <div class="list1" v-if="list && list.length > 0">
          <div
            class="item type2"
            v-for="(item, index) in list"
            :class="item.select && $route.query.from ? 'selected' : ''"
            :key="index"
            @click="handleSelect(item)">
            <div class="flexable">
              <div class="text text3">
                <div class="label">{{ item.name }},{{ item.phone }}</div>
                <div class="value">
                  <span v-if="item.address2">{{ item.address2 }},</span
                  >{{ item.address1 }},{{ item.city }},{{ item.state }},{{
                    item.area
                  }}
                </div>
                <div class="control">
                  <span class="edi" @click="handleEdit($event, item)"
                    ><i class="el-icon-edit-outline"></i> {{ $t('edit') }}</span
                  >
                  <span class="del" @click="handleDelete($event, item)"
                    ><i class="el-icon-delete"></i> {{ $t('new.text36') }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="no-more" v-if="!queryParams.more">
            - {{ $t('add.text73') }} -
          </div>
        </div>
        <EmptyBox
          :text="$t('new.text67')"
          style="margin-top: 2rem"
          type="nft"
          v-if="list && list.length == 0" />
      </div>
      <div class="open-area" style="height: 0.5rem"></div>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :closeOnClickModal="false">
      <div class="pop-box">
        <div class="pop-title" ref="popupTitle">
          <span v-if="popType === 'add'">{{ $t('new.text35') }}</span>
          <span v-if="popType === 'edit'">{{ $t('new.text37') }}</span>
        </div>
        <el-form
          :model="modelForm"
          status-icon
          ref="modelForm"
          label-width="100px"
          label-position="top">
          <div
            class="scroll-box"
            :style="{ 'max-height': scrollHeight + 'px' }">
            <el-form-item
              prop="area"
              :label="$t('new.text39')"
              :rules="[
                {
                  required: true,
                  message: $t('new.text40'),
                  trigger: 'blur'
                }
              ]">
              <el-input v-model="modelForm.area"></el-input>
            </el-form-item>
            <el-form-item
              prop="name"
              :label="$t('new.text41')"
              :rules="[
                {
                  required: true,
                  message: $t('new.text40'),
                  trigger: 'blur'
                }
              ]">
              <el-input v-model="modelForm.name"></el-input>
            </el-form-item>
            <el-form-item
              prop="address1"
              :label="$t('new.text42')"
              :rules="[
                {
                  required: true,
                  message: $t('new.text40'),
                  trigger: 'blur'
                }
              ]">
              <el-input v-model="modelForm.address1"></el-input>
            </el-form-item>
            <el-form-item :label="$t('new.text68')" prop="address2">
              <el-input v-model="modelForm.address2"></el-input>
            </el-form-item>
            <el-form-item
              prop="city"
              :label="$t('new.text43')"
              :rules="[
                {
                  required: true,
                  message: $t('new.text40'),
                  trigger: 'blur'
                }
              ]">
              <el-input v-model="modelForm.city"></el-input>
            </el-form-item>
            <el-form-item
              prop="state"
              :label="$t('new.text44')"
              :rules="[
                {
                  required: true,
                  message: $t('new.text40'),
                  trigger: 'blur'
                }
              ]">
              <el-input v-model="modelForm.state"></el-input>
            </el-form-item>
            <el-form-item
              prop="postal_code"
              :label="$t('new.text45')"
              :rules="[
                {
                  required: true,
                  message: $t('new.text40'),
                  trigger: 'blur'
                }
              ]">
              <el-input v-model="modelForm.postal_code"></el-input>
            </el-form-item>
            <el-form-item
              prop="phone"
              :label="$t('new.text46')"
              :rules="[
                {
                  required: true,
                  message: $t('new.text40'),
                  trigger: 'blur'
                }
              ]">
              <el-input v-model="modelForm.phone"></el-input>
            </el-form-item>
          </div>

          <el-button
            style="margin-top: 0.3rem"
            type="primary"
            @click="submitForm('modelForm')"
            class="block el-button--white"
            >{{ $t('new.text38') }}</el-button
          >
        </el-form>
      </div>
      <div class="pop-close" ref="popupBtn" @click="handleClose"></div>
    </mt-popup>
  </div>
</template>
<script>
import {
  postAddressAdd,
  postAddressDelete,
  postAddressInfo,
  postAddressList,
  postAddressUpdate
} from '@/api/user'
import EmptyBox from '@/components/EmptyBox.vue'

export default {
  name: 'UserAddress',
  components: {
    EmptyBox
  },
  data() {
    return {
      list: null,
      popupVisible: false,
      queryParams: {
        page: 1,
        size: 10,
        more: true,
        fixScroll: 0 // 固定时的高度记录一下，切换tab时需要滚动到对应位置
      },
      popType: null,
      modelForm: {
        area: '',
        name: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        postal_code: '',
        phone: ''
      },
      currentId: null,
      scrollHeight: 0
    }
  },
  watch: {
    popupVisible: {
      handler(n) {
        this.$stopScroll(n)
      },
      deep: true
    },
    '$i18n.locale'() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    loadMore() {
      console.log('load')
      if (this.queryParams.more) {
        this.queryParams.page += 1
        this.getList()
      }
    },
    init() {
      this.getList()
    },
    getList() {
      this.loading = true
      let params = {
        page: this.queryParams.page,
        size: this.queryParams.size
      }
      postAddressList(params).then((res) => {
        this.loading = false
        if (!this.list) {
          this.list = []
        }
        this.list = this.list.concat(res.data.lists)
        let selectAddress
        if (localStorage.getItem('selectedAddress')) {
          selectAddress = JSON.parse(localStorage.getItem('selectedAddress'))
        }
        if (selectAddress) {
          let hasAddress = this.list.find((item) => {
            return item.id === selectAddress.id
          })
          if (hasAddress) {
            this.list = this.list.map((item) => {
              if (selectAddress && selectAddress.id === item.id) {
                item.select = true
              } else {
                item.select = false
              }
              return item
            })
          } else {
            this.list = this.list.map((item, index) => {
              if (index === 0) {
                item.select = true
              } else {
                item.select = false
              }
              return item
            })
          }
        } else {
          this.list = this.list.map((item, index) => {
            if (index === 0) {
              item.select = true
            } else {
              item.select = false
            }
            return item
          })
        }

        if (res.data.lists.length < this.queryParams.size) {
          this.queryParams.more = false
        }
        this.loading = false
      })
    },
    handleBack() {
      this.$router.back()
    },
    changeHeight() {
      this.$nextTick(() => {
        this.scrollHeight =
          document.body.clientHeight -
          this.$refs.popupTitle.clientHeight * 2 -
          this.$refs.popupBtn.clientHeight * 2
      })
    },
    handleChange1() {},
    handleSelect(item) {
      if (this.$route.query && this.$route.query.from) {
        localStorage.setItem('selectedAddress', JSON.stringify(item))
        this.handleBack()
      }
    },
    handleAdd() {
      this.popType = 'add'
      this.popupVisible = true
      this.changeHeight()
    },
    handleEdit(event, item) {
      event.stopPropagation()
      let params = {
        id: item.id
      }
      this.currentId = item.id
      postAddressInfo(params).then((res) => {
        this.modelForm = res.data
        this.popType = 'edit'
        this.popupVisible = true
        this.changeHeight()
      })
    },
    handleDelete(event, item) {
      event.stopPropagation()
      let params = {
        id: item.id
      }
      postAddressDelete(params).then((res) => {
        this.$toast({
          message: this.$t('success'),
          iconClass: 'icon icon-success'
        })
        this.list = null
        this.queryParams = {
          page: 1,
          size: 10,
          more: true,
          fixScroll: 0 // 固定时的高度记录一下，切换tab时需要滚动到对应位置
        }
        this.getList()
      })
    },
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.popType === 'add') {
            postAddressAdd(this[form]).then((res) => {
              this.$toast({
                message: this.$t('success'),
                iconClass: 'icon icon-success'
              })
              this.$refs[form].resetFields()
              this.list = null
              this.queryParams = {
                page: 1,
                size: 10,
                more: true,
                fixScroll: 0 // 固定时的高度记录一下，切换tab时需要滚动到对应位置
              }
              this.getList()
              this.popupVisible = false
            })
          } else if (this.popType === 'edit') {
            let params = this[form]
            params.id = this.currentId
            postAddressUpdate(params).then((res) => {
              this.$toast({
                message: this.$t('success'),
                iconClass: 'icon icon-success'
              })
              this.$refs[form].resetFields()
              this.list = null
              this.queryParams = {
                page: 1,
                size: 10,
                more: true,
                fixScroll: 0 // 固定时的高度记录一下，切换tab时需要滚动到对应位置
              }
              this.getList()
              this.popupVisible = false
            })
          }
        }
      })
    },
    handleClose() {
      console.log(8888)
      this.popType = null
      this.popupVisible = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/address.vue